module.exports = __webpack_public_path__ + "img/Flag_of_Burkina_Faso.8c9b84ac.svg";